import {
  Component,
  OnInit,
  AfterViewInit,
  OnChanges,
  Input,
  SimpleChanges,
  OnDestroy
} from "@angular/core";
import { TransportationNuclearStockpilesService } from "./service/widget-transportation-nuclear-stockpiles.service";
import * as Highcharts from "highcharts";
import addMore from "highcharts/highcharts-more";
import { TranslateService } from "@ngx-translate/core";
import { environment } from "../../../../../environments/environment";
import { LocalStorageService } from "../../../../shared/services/local-storage.service";
import { BroadcasterService } from "../../../../core/services/broadcaster.service";
import * as HSET from "./settings";
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
addMore(Highcharts);

@Component({
  selector: "app-widget-transportation-nuclear-stockpiles",
  templateUrl: "./widget-transportation-nuclear-stockpiles.component.html",
  styleUrls: ["./widget-transportation-nuclear-stockpiles.component.scss"],
  providers: [TransportationNuclearStockpilesService]
})
export class WidgetTransportationNuclearStockpilesComponent
  implements OnInit, OnChanges, OnDestroy {
      private unsubscribe: Subject<void> = new Subject();
  @Input() FILTERS;
  @Input() OPTIONS;
  @Input() TITLE;
  apiURL = environment.gateWayHost;
  highcharts: typeof Highcharts = Highcharts;
  chartOptions = HSET.chartData;
  errorMessage = "";
  widgetId = 27;
  mockChart = null;
  loadingChart = true;

  constructor(
    private translateService: TranslateService,
    private dataService: TransportationNuclearStockpilesService,
    private broadcaster: BroadcasterService,
    private localStorageService: LocalStorageService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (
      JSON.stringify(changes.FILTERS.currentValue) !==
        JSON.stringify(changes.FILTERS.previousValue) &&
      !changes.FILTERS.firstChange
    ) {
      this.getNuclearStockPiles();
    }
  }

  ngOnInit() {
    this.getNuclearStockPiles();
    this.broadcaster.listen("PAGE_WIDGET_DATA")
    .pipe(takeUntil(this.unsubscribe)).subscribe(() => {
      this.setWidgetData();
    });
  }
  setWidgetData() {
    const pageData = this.localStorageService.getItem("PAGE_WIDGET_DATA");
    if (pageData) {
      pageData.forEach(element => {
        if (element.widget_id === this.widgetId) {
          this.setTarget(element.target);
        }
      });
    }
  }

  setTarget(t) {
    if (this.chartOptions) {
      if(this.chartOptions.series.length>2){
        this.chartOptions.series[2].data = [];
      }
     for (let i = 0; i < this.chartOptions.series[0].data.length; i++) {
        this.chartOptions.series[2].data.push(t);
      }
    }
  }
  getNuclearStockPiles() {
    this.errorMessage = "";
    this.mockChart = null;
    this.loadingChart = true;

    const options = {
      url: this.OPTIONS && this.OPTIONS.api ? this.OPTIONS.api : "",
      params: this.FILTERS
    };
    this.dataService.getData(options)
    .pipe(takeUntil(this.unsubscribe)).subscribe(
      chartData => {
        if (chartData[0].data.length) {
          this.loadingChart = false;

          this.chartOptions = this.dataService.createChart(
            chartData,
            this.OPTIONS
          );
          this.setWidgetData();
        } else {
          this.loadingChart = true;

          this.errorMessage = "ERROR_MSG.NO_DATA";
          this.mockChart = HSET.chartData;
        }
      },
      error => {
        this.loadingChart = true;

        this.errorMessage = "ERROR_MSG.SYSTEM_ERROR";
        this.mockChart = HSET.chartData;
      }
    );
  }

  ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
      }
}
